import Component from 'components/pages/Security/Security.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('security');
export default buildPage(Component, {
  requiresAuthentication: false,
  metaData: {
    title: 'Security',
    description: 'Report security problems with the Qmee site and apps.',
  },
});
